"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormList = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var mobx_1 = require("mobx");
var fab_button_1 = require("../../components/button/fab.button");
var image_button_1 = require("../../components/button/image.button");
var import_poleforeman_button_1 = require("../../components/button/import-poleforeman.button");
var import_button_1 = require("../../components/button/import.button");
var icons_1 = require("../../components/icon/icons");
var menu_1 = require("../../components/menu/menu");
var menu_item_1 = require("../../components/menu/menu.item");
var mithril_component_1 = require("../../components/mithril.component");
var modal_service_1 = require("../../components/modal/modal.service");
var notification_service_1 = require("../../components/notification.toast/notification.service");
var table_1 = require("../../components/table/table");
var theme_1 = require("../../components/theme");
var index_1 = require("../../i18n/index");
var mithril_1 = require("../../mithril");
var page_1 = require("../../page/page");
var services_1 = require("../../services");
var index_2 = require("../../store/index");
var form_share_modal_1 = require("../form.share.modal/form.share.modal");
var form_delete_confirm_modal_1 = require("./form.delete.confirm.modal");
var form_import_ctrl_1 = require("./form.import.ctrl");
var form_import_modal_1 = require("./form.import.modal");
var form_import_poleforeman_modal_1 = require("./form.import.poleforeman.modal");
var form_list_style_1 = require("./form.list.style");
var spinner_modal_1 = require("./spinner.modal");
(0, theme_1.addStyles)(form_list_style_1.Style);
/** Display a list of forms */
var FormList = /** @class */ (function (_super) {
    tslib_1.__extends(FormList, _super);
    function FormList() {
        var _this = _super.call(this) || this;
        _this.validIPFLicense = null;
        _this.formRefreshLoading = null;
        _this.databases = mobx_1.observable.shallowArray();
        _this.checkForValidIPFLicense();
        _this.menu = new menu_1.MenuComponent({
            items: function () { return [
                {
                    view: menu_item_1.MenuItemComponent.view((0, index_1.Translate)(index_1.T.FORM_DELETE)),
                    action: function () { return _this.confirmRemoveForm(); },
                    visible: services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_FORM_DELETE)
                },
                {
                    view: menu_item_1.MenuItemComponent.view((0, index_1.Translate)(index_1.T.FORM_SHARE)),
                    action: function () { return _this.confirmShareForm(); },
                    visible: services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_FORM_SHARE) &&
                        services_1.Services.Department.moveableDepartments().length > 0
                },
                {
                    view: menu_item_1.MenuItemComponent.view((0, index_1.Translate)(index_1.T.FORM_REFRESH)),
                    action: function () {
                        _this.confirmRegenerateIKEPoleForemanForm();
                    },
                    visible: _this.refreshFormOptionVisible
                }
            ]; }
        });
        return _this;
    }
    Object.defineProperty(FormList.prototype, "refreshFormOptionVisible", {
        get: function () {
            var _this = this;
            var _a, _b, _c, _d;
            var isIkeAnalyst = services_1.Services.User.isIkeAnalyst(services_1.Services.User.current);
            if (this.selectedFormUuid == null) {
                return false;
            }
            var form = index_2.AppStore.FormSummary.all.find(function (summary) { return summary.uuid === _this.selectedFormUuid; });
            var isIPFForm = ((_a = form === null || form === void 0 ? void 0 : form.metadata) === null || _a === void 0 ? void 0 : _a.ikePoleForeman) || false;
            if (!isIPFForm) {
                return false;
            }
            var currentOrgAccessId = (_b = services_1.Services.Department.currentOrg) === null || _b === void 0 ? void 0 : _b.accessOrgId;
            if (!currentOrgAccessId) {
                return false;
            }
            var formIsFromSameAccessOrg = ((_d = (_c = form === null || form === void 0 ? void 0 : form.metadata) === null || _c === void 0 ? void 0 : _c.ikePoleForeman) === null || _d === void 0 ? void 0 : _d.accessOrgId) === currentOrgAccessId;
            if (!formIsFromSameAccessOrg) {
                return false;
            }
            var hasValidPermissions = this.validIPFLicense === true && (isIkeAnalyst || services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_IPF_DB_IMPORT));
            return hasValidPermissions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormList.prototype, "nodes", {
        get: function () {
            var isIkeAnalyst = services_1.Services.User.isIkeAnalyst(services_1.Services.User.current);
            var hasImportToken = services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_IMPORT_FORM);
            var hasIPFImportToken = services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_IPF_DB_IMPORT);
            return (0, mithril_1.m)('div', { className: form_list_style_1.CSS.container }, tslib_1.__spreadArray(tslib_1.__spreadArray([
                this.viewForms(),
                fab_button_1.FabButton.view({
                    title: index_1.T.FORM_CREATE,
                    onclick: function () { return services_1.Services.Route.go(page_1.IkePageName.formNew); }
                })
            ], ((isIkeAnalyst || hasImportToken) ?
                [import_button_1.ImportButton.view({
                        title: index_1.T.FORM_CREATE,
                        onclick: function () {
                            var formImportModalCtrl = new form_import_ctrl_1.FormImportCtrl();
                            var formImportModal = new form_import_modal_1.FormImportModal(formImportModalCtrl);
                            formImportModal.open();
                        }
                    })] : []), true), ((isIkeAnalyst || hasIPFImportToken) ?
                [import_poleforeman_button_1.ImportPoleforemanButton.view({
                        title: index_1.T.FORM_NEW_POLEFOREMAN_FORM,
                        onclick: function () {
                            var formImportPoleForemanModal = new form_import_poleforeman_modal_1.FormImportPoleforemanModal();
                            formImportPoleForemanModal.open();
                        }
                    })] : []), true));
        },
        enumerable: false,
        configurable: true
    });
    FormList.prototype.viewForms = function () {
        var headers = [
            '#',
            "".concat((0, index_1.Translate)(index_1.T.FORM_NAME), " (").concat((0, index_1.Translate)(index_1.T.FORM_VERSION), ")"),
            (0, index_1.Translate)(index_1.T.FORM_DESCRIPTION),
            (0, index_1.Translate)(index_1.T.FORM_UPDATED_AT),
            ''
        ];
        var rows = [];
        var forms = index_2.AppStore.FormSummary.all;
        for (var i = 0; i < forms.length; i++) {
            rows.push(this.viewForm(forms[i], i));
        }
        return table_1.Table.view((0, index_1.Translate)(index_1.T.FORM_TITLE), headers, rows);
    };
    FormList.prototype.viewForm = function (form, index) {
        var displayName = form.displayname;
        if (form.displayversion && form.displayversion > 0) {
            displayName = "".concat(displayName, " (V").concat(form.displayversion, ")");
        }
        return [
            (0, mithril_1.m)('span', { className: form_list_style_1.CSS.tableCell }, String(index + 1)),
            (0, mithril_1.m)('a', {
                className: "mdl-button mdl-ripple-effect mdl-button--accent ".concat(form_list_style_1.CSS.tableCell, " ").concat(form_list_style_1.CSS.tableCellButton),
                title: (0, index_1.Translate)(index_1.T.FORM_EDIT),
                href: services_1.Services.Route.getRouteURL(page_1.IkePageName.formEdit, {
                    version: form.revision
                })
            }, displayName),
            (0, mithril_1.m)('div', { className: "".concat(form_list_style_1.CSS.tableCell, " ").concat(form_list_style_1.CSS.tableCellFaint, " ") }, form.description),
            (0, mithril_1.m)('div', { className: "".concat(form_list_style_1.CSS.tableCell, " ").concat(form_list_style_1.CSS.tableCellFaint, " ") }, services_1.Services.DateTime.formatDateTime(form.updatedAt)),
            (0, mithril_1.m)('div', { className: form_list_style_1.CSS.tableCellMenu }, this.viewFormActions(form))
        ];
    };
    FormList.prototype.viewFormActions = function (form) {
        var _this = this;
        if (!this.menu.hasUsableItems) {
            return null;
        }
        return [
            image_button_1.ImageButton.view(icons_1.MaterialIcon.MORE_VERT, {
                onclick: function () {
                    _this.setSelectedFormUuid(form.uuid);
                    _this.menu.show();
                }
            }),
            this.selectedFormUuid === form.uuid ? this.menu.view() : null
        ];
    };
    FormList.prototype.setSelectedFormUuid = function (uuid) {
        this.selectedFormUuid = uuid;
    };
    FormList.prototype.confirmRemoveForm = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var form, confirmModal;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (this.selectedFormUuid == null) {
                    return [2 /*return*/];
                }
                form = index_2.AppStore.FormSummary.all.find(function (summary) { return summary.uuid === _this.selectedFormUuid; });
                confirmModal = new form_delete_confirm_modal_1.FormDeleteConfirmModal({
                    title: index_1.T.FORM_DELETE_TITLE,
                    confirm: index_1.T.FORM_DELETE,
                    success: {
                        key: index_1.T.FORM_DELETE_SUCCESS,
                        attrs: {
                            name: form.displayname
                        }
                    }
                }, form);
                confirmModal.open();
                return [2 /*return*/];
            });
        });
    };
    FormList.prototype.confirmShareForm = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var form, confirmModal;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (this.selectedFormUuid == null) {
                    return [2 /*return*/];
                }
                form = index_2.AppStore.FormSummary.all.find(function (summary) { return summary.uuid === _this.selectedFormUuid; });
                confirmModal = new form_share_modal_1.FormShareModal({
                    title: index_1.T.FORM_SHARE_TITLE,
                    confirm: index_1.T.FORM_SHARE,
                    success: {
                        key: index_1.T.FORM_SHARE_SUCCESS,
                        attrs: {
                            name: form.displayname
                        }
                    }
                }, form.revision);
                confirmModal.open();
                return [2 /*return*/];
            });
        });
    };
    FormList.prototype.confirmRegenerateIKEPoleForemanForm = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var form, confirmModal;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.selectedFormUuid == null) {
                            return [2 /*return*/];
                        }
                        form = index_2.AppStore.FormSummary.all.find(function (summary) { return summary.uuid === _this.selectedFormUuid; });
                        if (!form) {
                            return [2 /*return*/];
                        }
                        confirmModal = new spinner_modal_1.SpinnerModal({
                            title: index_1.T.FORM_REFRESH_MODAL_TITLE,
                            // confirm and success will not be used
                            confirm: index_1.T.OK,
                            success: {
                                key: index_1.T.FORM_REFRESH_SUCCESS,
                                attrs: {
                                    name: form.displayname
                                }
                            },
                            cancel: index_1.T.CLOSE
                        });
                        confirmModal.open();
                        // Refresh the form
                        return [4 /*yield*/, services_1.Services.Department.rest.Form.Pla.importPoleforeman({
                                existingFormVersion: form.revision
                            }).then(function () {
                                // if the form is successfully refreshed, we show a success message
                                confirmModal.close();
                                // we need to refresh the form list
                                index_2.AppStore.FormSummary.refresh();
                                notification_service_1.NotificationService.success({
                                    key: index_1.T.FORM_REFRESH_SUCCESS, attrs: {
                                        name: form.displayname
                                    }
                                });
                            }).catch(function (error) {
                                // if there is an error, we need to show it in the modal
                                confirmModal.setModalResult([(0, index_1.Translate)(index_1.T.FORM_REFRESH_MODAL_ERROR, { name: form.displayname }), error.message]);
                                modal_service_1.ModalService.setTitle(index_1.T.FORM_REFRESH_MODAL_TITLE_ERROR);
                            })];
                    case 1:
                        // Refresh the form
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FormList.prototype.checkForValidIPFLicense = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var rest, ipfLicenseCheckResult;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        rest = services_1.Services.Department.rest;
                        return [4 /*yield*/, rest.Form.Pla.getRefreshPermission({})];
                    case 1:
                        ipfLicenseCheckResult = _a.sent();
                        this.validIPFLicense = ipfLicenseCheckResult.success;
                        return [2 /*return*/];
                }
            });
        });
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], FormList.prototype, "selectedFormUuid", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FormList.prototype, "validIPFLicense", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FormList.prototype, "formRefreshLoading", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FormList.prototype, "databases", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FormList.prototype, "setSelectedFormUuid", null);
    return FormList;
}(mithril_component_1.IMithrilStateComponent));
exports.FormList = FormList;
//# sourceMappingURL=form.list.js.map